/**
 * @generated SignedSource<<eced6605fe822c8199f6d705379dd23d>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AgentPoolPageRemoveAgentPoolMutation$variables = {
  agentPoolRawId: string;
};
export type AgentPoolPageRemoveAgentPoolMutation$data = {
  readonly removeAgentPool: {
    readonly agentPool: {
      readonly name: string | null | undefined;
      readonly rawId: string;
    } | null | undefined;
  } | null | undefined;
};
export type AgentPoolPageRemoveAgentPoolMutation = {
  response: AgentPoolPageRemoveAgentPoolMutation$data;
  variables: AgentPoolPageRemoveAgentPoolMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "agentPoolRawId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "agentPoolRawId",
            "variableName": "agentPoolRawId"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "RemoveAgentPoolPayload",
    "kind": "LinkedField",
    "name": "removeAgentPool",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ShallowAgentPool",
        "kind": "LinkedField",
        "name": "agentPool",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rawId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AgentPoolPageRemoveAgentPoolMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "AgentPoolPageRemoveAgentPoolMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "1894dbcff80b0d2d5c939278c570a2ff",
    "id": null,
    "metadata": {},
    "name": "AgentPoolPageRemoveAgentPoolMutation",
    "operationKind": "mutation",
    "text": "mutation AgentPoolPageRemoveAgentPoolMutation(\n  $agentPoolRawId: ID!\n) {\n  removeAgentPool(input: {agentPoolRawId: $agentPoolRawId}) {\n    agentPool {\n      rawId\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2dfd8ebb69b9a5dab5e9a2fff74a3fd9";

export default node;
